module.exports = __webpack_public_path__ + "img/ezgif.com-optimize_3.ebf125c5.gif";